import { LightMode } from '@/interfaces/LightMode';
import gql from 'graphql-tag';

export const rhythmPointFields = gql`
  fragment rhythmPointFields on RhythmPoint {
    hours
    minutes
    type
    dimming
    mode {
      ...lightModeFields
    }
  }
`;

export type RhythmPointFields = {
  __typename: 'RhythmPointFields';
  hours: number;
  minutes: number;
  type: string;
  dimming: number;
  mode: LightMode;
};
